import React, { useState } from "react";
import { FaTimes, FaBuilding, FaUserTie, FaEnvelope, FaPhoneAlt, FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";

export default function InviteAccountantModal({ onClose }) {
  const [formData, setFormData] = useState({
    companyName: "",
    ownerName: "",
    email: "",
    phone: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.companyName || !formData.ownerName || !formData.email) {
      toast.error("Please fill in all required fields.");
      return;
    }

    setIsSubmitting(true);
    // Simulate API call for sending invitation
    setTimeout(() => {
      toast.success("Invitation sent successfully!");
      setIsSubmitting(false);
      onClose();
    }, 1000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="invite-modal-overlay">
      <div className="invite-modal-content">
        <button className="invite-modal-close" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="invite-modal-header">
          <h2>Add Accountant</h2>
          <p>Send an invitation to join your workspace.</p>
        </div>

        <div className="invite-modal-body">
          <form className="invite-form-col" onSubmit={handleSubmit}>
            <div className="invite-form-group">
              <label>
                <FaBuilding /> Accountancy Company Name
              </label>
              <input
                type="text"
                name="companyName"
                placeholder="e.g. Apex Solutions Pvt Ltd"
                value={formData.companyName}
                onChange={handleChange}
              />
            </div>

            <div className="invite-form-group">
              <label>
                <FaUserTie /> Accountant Name
              </label>
              <input
                type="text"
                name="ownerName"
                placeholder="e.g. John Doe"
                value={formData.ownerName}
                onChange={handleChange}
              />
            </div>

            <div className="invite-form-group">
              <label>
                <FaEnvelope /> Email ID
              </label>
              <input
                type="email"
                name="email"
                placeholder="e.g. johndoe@example.com"
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="invite-form-group">
              <label>
                <FaPhoneAlt /> Phone Number (optional)
              </label>
              <input
                type="text"
                name="phone"
                placeholder="e.g. 9876543210"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            
            <div className="invite-modal-footer">
              <button type="button" className="invite-btn-cancel" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="invite-btn-send" disabled={isSubmitting}>
                {isSubmitting ? "Sending..." : <><FaCheck /> Send Invitation</>}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
